const ajax = require('sma.common/ajax');
const Grid = require('sma.admin/components/grid');
const Dropdown =  require('sma.admin/components/dropdowns/dropdown');
const Rely =  require('sma.admin/components/rely');
const modals = require('sma.common/components/modals');
const TextEditor = require('sma.common/texteditor');

const userTempl = require('sma.applicant/organizations/partials/user.mustache');
const gridToggleTempl = require('sma.applicant/organizations/partials/site_members_toggle.mustache');
const membersDropdownTempl = require('sma.applicant/organizations/partials/teams_dropdown.mustache');

let toggleAccess = (ids, grid) => {
	ajax.post({
		url: reverse('org-members-access'),
		data: {ids},
		callback: (response) => { grid.load(); }
	});
};

let toggleRole = (ids, grid) => {
	ajax.post({
		url: reverse('org-members-role'),
		data: {ids},
		callback: (response) => { grid.load(); }
	});
};

let sendInvite = (ids, grid) => {
	ajax.post({
		url: reverse('org-members-invite'),
		data: {ids},
		callback: (response) => { grid.load(); }
	});
};

let activate = (ids, grid) => {
	ajax.post({
		url: reverse('org-members-activate'),
		data: {ids},
		callback: (response) => { grid.load(); }
	});
};

let deactivate = (ids, grid) => {
	ajax.post({
		url: reverse('org-members-deactivate'),
		data: {ids},
		callback: (response) => { grid.load(); }
	});
};

let removeMembers = (ids, grid) => {
	new modals.Confirm(
		gettext('Delete from organization'),
		gettext('Are you sure you want to delete the selected members \
			from the organization?<br>Any applications they own will \
			transfer to the primary admin.'),
		() => {
			ajax.post({
				url: reverse('org-members-remove'),
				data: {ids},
				callback: (response) => { grid.load(); }
			});
		}
	);
};

let addMembers = (grid) => {
	let addMembersModal = new modals.AjaxFormModal({
		size: 'lg',
		destroyOnClose: true,
		autoShow: true,
		onSuccess: (_modal) => {
			addMembersModal.hide();
			grid.load();
		}
	});

	let addMembersContent = new modals.AjaxFormContent(
		reverse('org-members-add'),
		{
			buttons: [{
				label: gettext('CANCEL'),
				cls: 'btn-secondary',
				handler: (modal) => {
					modal.hide();
				}
			}, {
				label: gettext('ADD'),
				cls: 'btn-primary',
				handler: (modal) => {
					modal.modalBody.find('form').submit();
				}
			}],
			onLoad: () => {
				new Rely();
				$('.sma-js-import-members').off();
				$('.sma-js-import-members').on('click', function() {
					addMembersModal.switchToContent('ImportMembers');
				});
			}
		}
	);

	let importMembersContent = new modals.AjaxFormContent(
		reverse('org-members-import'),
		{
			buttons: [{
				label: gettext('Cancel'),
				cls: 'btn-secondary',
				handler: (modal) => {
					modal.hide();
				}
			}, {
				label: gettext('Import'),
				cls: 'btn-primary',
				handler: (modal) => {
					let form = modal.modalBody.find('#import-users-form');
					form.submit();
				}
			}],
			onLoad: () => {
				new Rely();
			}
		}
	);

	addMembersModal.addToStack('AddMembers', addMembersContent);
	addMembersModal.addToStack('ImportMembers', importMembersContent);
};

let updateTeamMembership = (ids, grid) => {
	let teamMembershipModal = new modals.AjaxFormModal({
		size: 'md',
		destroyOnClose: true,
		autoShow: true,
		onSuccess: (modal) => {
			teamMembershipModal.hide();
			grid.load();
		}
	});

	let teamMembershipContent = new modals.AjaxFormContent(
		reverse('org-members-teams') + '?' + $.param({ids}),
		{
			buttons: [{
				label: gettext('CANCEL'),
				cls: 'btn-secondary',
				handler: (modal) => {
					modal.hide();
				}
			}, {
				label: gettext('OK'),
				cls: 'btn-primary',
				handler: (modal) => {
					modal.modalBody.find('form').submit();
				}
			}]
		}
	);

	teamMembershipModal.addToStack('TeamMembership', teamMembershipContent);
};

let sendEmail = (grid, id=null) => {
	let ids = id !== null ? [id] : grid.selectedIds;

	if (ids.length === 0) {
		grid.nothingSelected();
		return;
	}

	let emailModal = new modals.AjaxFormModal({
		size: 'md',
		destroyOnClose: true,
		autoShow: true,
		onSuccess: (modal) => {
			emailModal.hide();
			grid.load();
		}
	});

	let emailContent = new modals.AjaxFormContent(
		reverse('org-members-email') + '?' + $.param({ids}),
		{
			buttons: [{
				label: gettext('CANCEL'),
				cls: 'btn-secondary',
				handler: (modal) => {
					modal.hide();
				}
			}, {
				label: gettext('SEND'),
				cls: 'btn-primary',
				handler: (modal) => {
					modal.modalBody.find('form').submit();
				}
			}],
			onLoad: () => {
				new TextEditor({
					textarea: $('textarea.sma-text-editor'),
					piping: null
				});
			}
		}
	);

	emailModal.addToStack('Email', emailContent);
};

let OrganizationMembersGrid = Grid.Grid.extend({
	gridLabel: gettext('member'),
	orderCols: ['name', 'email', 'last_login', 'signup_date', 'active', 'role'],
	columns: [
		{
			id: 'name',
			name: gettext('Name'),
			formatter(item, grid) {
				return userTempl({
					initials: item.initials,
					name: item.name
				});
			}
		}, {
			id: 'email',
			name: gettext('Email'),
		}, {
			id: 'role',
			name: gettext('Role'),
		}, {
			id: 'teams',
			name: gettext('Teams'),
			formatter(item, grid) {
				if (item.teams.length < 3) {
					return item.teams.join(', ');
				}
				let strings = {
					teams: gettext('teams')
				}
				return membersDropdownTempl({
					strings: strings,
					teams_count: item.teams.length,
					teams: item.teams
				})
			}
		}, {
			id: 'last_login',
			name: gettext('Last login'),
			formatter: (item, grid) => {
				if (item.status === 'active') {
					return item.last_login_pretty;
				}
				else if (item.status === 'invited') {
					return interpolate(gettext('Invited: %(date)s'), {date: item.last_login_pretty}, true);
				}
				else if (item.status === 'inactive') {
					return gettext('No invite sent');
				}
			},
		}, {
			id: 'signup_date',
			name: gettext('Signup date'),
			formatter(item, grid) {
				return item.signup_date_pretty;
			}
		}, {
			id: 'active',
			name: gettext('Active'),
			formatter(item, grid) {
				return item.active ? '<i class="nc-icon-mini ui-1_check-simple"></i>' : '';
			}
		}, {
			name: '',
			id: 'actions',
			alwaysDisplayed: true,
			formatter: (item, grid) => {
				if (item.is_primary_admin) return;

				return new Dropdown({
					className: 'pull-xs-right btn-group sma-hideable-menu',
					type: 'heading',
					noCaret: true,
					title: '<i class="nc-icon-mini ui-2_menu-dots"></i>',
					rightAligned: true,
					items: $.grep([
						{
							name: 'email',
							text: gettext('Email'),
							action: (args) => {
								sendEmail(grid, item.id);
							}
						}, {
							name: 'team_membership',
							text: gettext('Change team membership'),
							action: (args) => {
								updateTeamMembership([item.id], grid);
							}
						}, item.is_active ? null : {
							name: 'resend_invite',
							text: gettext('Resend invite'),
							extraItemClass: item.active ? 'disabled' : null,
							action: (args) => {
								sendInvite([item.id], grid);
							}
						}, {
							name: 'toggle_role',
							text: gettext('Toggle role'),
							action: (args) => {
								toggleRole([item.id], grid);
							}
						}, item.active ? null : {
							name: 'activate',
							text: gettext('Activate'),
							action: (args) => {
								activate([item.id], grid);
							}
						}, !item.active ? null : {
							name: 'deactivate',
							text: gettext('Deactivate'),
							action: (args) => {
								deactivate([item.id], grid);
							}
						}, {
							name: 'toggle_access',
							text: gettext('Toggle site access'),
							action: (args) => {
								toggleAccess([item.id], grid);
							}
						}, !item.can_delete ? null : {
							name: 'delete',
							text: gettext('Delete from organization'),
							action: (args) => {
								removeMembers([item.id], grid);
							}
						}
					], (x) => x != null),
					addActionData: () => ({ grid })
				}).$el;
			},
		}
	],
	actions: [
		{
			name: 'team_membership',
			text: gettext('Change team membership'),
			action: (args) => {
				updateTeamMembership(args.ids, args.grid);
			}
		}, {
			name: 'resend_invite',
			text: gettext('Resend invite'),
			action: (args) => {
				sendInvite(args.ids, args.grid);
			}
		}, {
			name: 'toggle_role',
			text: gettext('Toggle role'),
			action: (args) => {
				toggleRole(args.ids, args.grid);
			}
		}, {
			name: 'toggle_access',
			text: gettext('Toggle site access'),
			action: (args) => {
				toggleAccess(args.ids, args.grid);
			}
		}, {
			name: 'delete',
			text: gettext('Delete from organization'),
			action: (args) => {
				removeMembers(args.ids, args.grid);
			}
		}
	],
	extraToolbarItems: (grid) => {
		return [
			{
				trigger: 'click',
				html: '<button class="btn btn-default"><i class="nc-icon-mini ui-1_email-83"></i></button>',
				action: (data) => {
					sendEmail(grid);
				}
			}, {
				trigger: 'click',
				html: '<button class="btn btn-default">'+gettext('Add member')+'</button>',
				action: (data) => {
					addMembers(grid);
				}
			}
		];
	},
	onLoad: (grid, data) => {
		for (let row of data.results) {
			if (!row.is_in_current_site) {
				grid.$el
					.find(`tr[name="${row.id}"] td`)
					.not('td[role="actions"], td[role="select"]')
					.css('opacity', 0.5);
			}
		}
	},
	renderExtraToggle: () => {
		return gridToggleTempl({});
	}
});

module.exports = {
	OrganizationMembersGrid
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/organizations/members.js